import script from "./RegisterMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterMain.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterMain.vue?vue&type=style&index=0&id=108eea99&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-108eea99"]])

export default __exports__